import React, { useState, useEffect } from "react";
import ReactPaginate from "react-paginate";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const tableWrapperStyle = {
  maxWidth: "100%",
  overflowX: "auto",
  overflowY: "hidden",
  WebkitOverflowScrolling: "touch",
};

const tableStyle = {
  minWidth: "1810px",
  tableLayout: "fixed",
};

const thStyle = {
  verticalAlign: "bottom",
  whiteSpace: "normal",
  wordBreak: "break-word",
};

const tdStyle = {
  verticalAlign: "top",
  wordBreak: "break-word",
};

const warningColumnStyle = {
  backgroundColor: "#fff3cd",
};

const warningThStyle = {
  ...thStyle,
  ...warningColumnStyle,
};

const warningTdStyle = {
  ...tdStyle,
  ...warningColumnStyle,
};

const ActionCards = () => {
  const itemsPerPage = 10;

  const [singledata, setSingledata] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageCount, setPageCount] = useState(1);
  const [loading, setLoading] = useState(true);
  const jwtToken = localStorage.getItem("jwt_token");
  const history = useHistory();
  const [filterInput, setFilterInput] = useState("");

  const Single = async (page) => {
    let url = `${process.env.REACT_APP_API_URL}/actioncard?page=${page}&limit=${itemsPerPage}&search=${filterInput}`;
    fetch(url, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    })
      .then((res) => {
        return res.json();
      })
      .then((data) => {
        const codeMessage = data.data.actioncard_details;
        setLoading(false);
        if (codeMessage) {
          setSingledata(codeMessage);
          setPageCount(Math.ceil(data.data.count / itemsPerPage));
        } else {
          toast.error("Something went wrong, Please try again later");
          setLoading(false);
        }
      });
  };

  useEffect(() => {
    const data = setTimeout(() => {
      Single(currentPage);
    }, 500);
    return () => {
      clearTimeout(data);
    };
  }, [filterInput]);

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
    Single(event.selected + 1);
  };

  return (
    <>
      {loading ? (
        <div className="text-center" style={{ width: "100%" }}>
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      ) : (
        <>
          <>
            <div className="row my-2 align-items-center">
              <div className="col-12 col-md-3 mb-2 mb-md-0">
                Action-card table
              </div>
              <div className="col-12 col-md-5 mb-2 mb-md-0 d-flex align-items-center">
                <span className="mr-2 flex-shrink-0">Search and filters:</span>
                <input
                  type="text"
                  className="form-control"
                  placeholder="E.g. Filter for “English Name, AC No"
                  value={filterInput}
                  style={{ maxWidth: 320 }}
                  onChange={(e) => {
                    setFilterInput(e.target.value);
                  }}
                />
              </div>
              <div className="col-12 col-md-4 d-flex justify-content-md-end">
                <Link to="/action-cards/add-action-card">
                  <button
                    className="btn responsive-btn bg_color fs-8 m-1"
                    type="text"
                  >
                    Add New Action-card
                  </button>
                </Link>
              </div>
            </div>
          </>
          <div className="alert alert-warning py-2 mb-3" role="alert">
            <strong>Notice:</strong> Chirag mentioned that this section will be removed, so please update your data for available countries/languages. Once done, please let Chirag know so he can remove this column also.
          </div>
          <div style={tableWrapperStyle}>
          <table className="table mb-0" style={tableStyle}>
            <colgroup>
              <col style={{ width: 70 }} />
              <col style={{ width: 180 }} />
              <col style={{ width: 120 }} />
              <col style={{ width: 130 }} />
              <col style={{ width: 130 }} />
              <col style={{ width: 140 }} />
              <col style={{ width: 90 }} />
              <col style={{ width: 130 }} />
              <col style={{ width: 100 }} />
              <col style={{ width: 130 }} />
              <col style={{ width: 130 }} />
              <col style={{ width: 110 }} />
              <col style={{ width: 130 }} />
              <col style={{ width: 90 }} />
            </colgroup>
            <thead>
              <tr>
                <th scope="col" style={thStyle}>AC No</th>
                <th scope="col" style={thStyle}>English Name</th>
                <th scope="col" style={thStyle}>English Short name</th>
                <th scope="col" style={thStyle}>Client Type</th>
                <th scope="col" style={warningThStyle}>Target country</th>
                <th scope="col" style={thStyle}>Combined Code</th>
                <th scope="col" style={thStyle}>Format</th>
                <th scope="col" style={thStyle}>Purpose Type</th>
                <th scope="col" style={warningThStyle}>Lang.</th>
                <th scope="col" style={thStyle}>Standard or Tailored</th>
                <th scope="col" style={thStyle}>Version numbers and AC-pdf file</th>
                <th scope="col" style={thStyle}>AC docum.</th>
                <th scope="col" style={thStyle}>Remarks</th>
                <th scope="col" style={thStyle}>Action</th>
              </tr>
            </thead>
            <tbody>
              {singledata.map((item, i) => {
                return (
                  <tr key={item.id}>
                    <th scope="row">{item.ac_no}</th>
                    <td style={tdStyle}>{item.english_name}</td>
                    <td style={tdStyle}>{item.english_short_name}</td>
                    <td style={tdStyle}>{item.client_type.join(", ")}</td>
                    <td style={warningTdStyle}>{item.target_company.join(", ")}</td>
                    <td style={tdStyle}>
                      {Array.isArray(item.combined_code)
                        ? item.combined_code.join(", ")
                        : item.combined_code || ""}
                    </td>
                    <td style={tdStyle}>{item.format.join(", ")}</td>
                    <td style={tdStyle}>{item.purpose_type}</td>
                    <td style={warningTdStyle}>{item.language.join(", ")}</td>
                    <td style={tdStyle}>{item.standard_and_tailored}</td>
                    {/* map left */}
                    <td style={tdStyle}>
                      {item.version_pdf_file.length >= 1
                        ? item.version_pdf_file[
                            item.version_pdf_file.length - 1
                          ].version
                        : null}
                    </td>
                    <td style={tdStyle}>
                      {item.version_pdf_file.length >= 1
                        ? item.version_pdf_file[
                            item.version_pdf_file.length - 1
                          ].pdf_file
                        : null}
                    </td>
                    <td style={tdStyle}>{item.remarks ? item.remarks.substring(0, 20) : ""}</td>
                    <td style={tdStyle}>
                      {/* <i
                    type="button"
                    className="nav-icon fas fa-edit btn btn-lg bg_color"
                    // onClick={() => {
                    //   window.open(
                    //     `/action-cards/add-action-card?id=${item.id}`
                    //   );
                    // }}
                    onClick={() => {
                      history.push({
                        pathname: `/action-cards/add-action-card`,
                        search: `?id=${item.id}`,
                      });
                    }}
                    ></i> */}
                      <i
                        type="button"
                        className="nav-icon fas fa-edit btn btn-lg bg_color"
                        onClick={() => {
                          history.push({
                            pathname: `/action-cards/add-action-card`,
                            search: `?id=${item.id}`,
                          });
                        }}
                      ></i>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          </div>
        </>
      )}
      <ReactPaginate
        nextLabel="Next"
        onPageChange={handlePageClick}
        pageRangeDisplayed={10}
        pageCount={pageCount}
        previousLabel="Previous"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link bg_color"
        containerClassName="pagination"
        activeClassName="active"
        renderOnZeroPageCount={null}
      />
    </>
  );
};
export default ActionCards;
